import { IMPURITY } from "./constants";

/**
 * 使用できる機能が不適合品登録のみかどうかを判定する
 */
export const isImpurityCheck = (features: readonly string[]) =>
  features.length === 1 && features[0] === IMPURITY;
